const API_BASE =
  process.env.NODE_ENV === "production" ? "/api" : "http://localhost:3001/api";

async function request(url, options = {}) {
  const response = await fetch(`${API_BASE}${url}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`HTTP ${response.status}: ${text || response.statusText}`);
  }
  return response.json();
}

// Health
export const getHealth = () => request("/health");

// Content CRUD
export const getContent = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return request(`/content${qs ? "?" + qs : ""}`);
};

export const getContentById = (id) => request(`/content/${id}`);

export const createContent = (data) =>
  request("/content", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateContent = (id, data) =>
  request(`/content/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const deleteContent = (id) =>
  request(`/content/${id}`, { method: "DELETE" });

export const updateStatus = (id, status) =>
  request(`/content/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });


// ✅ Actualizar fecha de visualización (YYYY-MM-DD o null para borrar)
export const updateWatchedDate = (id, watched_date) =>
  request(`/content/${id}`, {
    method: "PUT",
    body: JSON.stringify({ watched_date }),
  });

// TMDB Search
export const searchTMDB = (query, type = "multi") =>
  request(
    `/search?q=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}`,
  );

export const getDetails = (tmdbId, type = "movie") =>
  request(`/search/details/${tmdbId}?type=${encodeURIComponent(type)}`);

// Import
export const importContent = (items) =>
  request("/import", {
    method: "POST",
    body: JSON.stringify({ items }),
  });
